import { render, staticRenderFns } from "./FormRecord.vue?vue&type=template&id=4467c8be&scoped=true&"
import script from "./FormRecord.vue?vue&type=script&lang=js&"
export * from "./FormRecord.vue?vue&type=script&lang=js&"
import style0 from "./FormRecord.vue?vue&type=style&index=0&id=4467c8be&lang=scss&scoped=true&"
import style1 from "./FormRecord.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4467c8be",
  null
  
)

export default component.exports